// extracted by mini-css-extract-plugin
var _1 = "ProtectedView__button--CgcFc CoreGeneral__blueToCyanButton--Svceh CoreGeneral__colorButton--ZcxJ7 CoreGeneral__colorButtonBase--ROvbs CoreGeneral__roboto--UlmjE";
var _2 = "ProtectedView__main--MKAEc CoreGeneral__roboto--UlmjE";
export { _1 as "button", _2 as "main" }
